import * as React from 'react';
import { ChangeEvent } from 'react';
import './Checkbox.css';

interface Props {
    onChange: (value: boolean) => void;
    value?: boolean;
}

export default class Checkbox extends React.PureComponent<Props> {
    public render(): JSX.Element {
        return (
            <label className="container-checkbox">
                <input type="checkbox" checked={this.props.value} onChange={this.valueChanged} />
                <span className="checkmark" />
            </label>
        );
    }

    private valueChanged = (e: ChangeEvent<HTMLInputElement>): void => this.props.onChange(e.currentTarget.checked);
}



// WEBPACK FOOTER //
// ./src/view/common/Checkbox.tsx